import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from '../PrimaryButton';
import { globalStyles } from '../style/gstheme';

const styles = Object.assign({
}, globalStyles);

class SynchronisationDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true
        };
        this.cancellable = null;
    }

    exit = () => {
        this.setState({ open: false });
        this.props.onExit();
    }

    render() {

        const { open } = this.state;
        const { classes, processing } = this.props;

        return (
            <Dialog
                maxWidth="md"
                fullWidth
                classes={{
                    paperWidthMd: classes.mediumDialog
                }}
                className={classes.dialog}
                open={processing || open}
                onClose={this.exit} aria-labelledby="integration-dialog-title">
                <DialogTitle disableTypography className={classes.mainHeading} id="integration-dialog-title">Synchronising Data</DialogTitle>
                <DialogContent>
                    <Typography variant="body2">{processing ? "Please wait. Sending data." : "Processing complete."}</Typography>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <PrimaryButton disabled={processing} onClick={this.exit}>Close</PrimaryButton>
                </DialogActions>
            </Dialog>
        );
    }
}

SynchronisationDialog.defaultProps = {
}

SynchronisationDialog.propTypes = {
    classes: PropTypes.object,
    onExit: PropTypes.func,
    processing: PropTypes.bool
}

export default withStyles(styles)(SynchronisationDialog)
